/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SeeDeliveryOptionsV2 = 'Website.Basket.Shipping.SeeDeliveryOptionsV2';
export const DeliveryOptions = 'Website.Basket.Shipping.DeliveryOptions';
